import { HttpMethods, makeRequest } from '../helpers/http.helper';
import type {
  Zone,
  ZoneCollectionPointsResponse,
  ZoneInput,
  ZonePagination,
  ZoneQuery,
  ZoneUpdateInput,
} from '../types/zone.type';

interface GenericResponse<T> {
  result: T;
}

export async function listZones(params: ZoneQuery): Promise<ZonePagination> {
  const response = await makeRequest({
    url: '/ops/zones',
    method: HttpMethods.GET,
    params,
  }) as GenericResponse<ZonePagination>;
  return response.result;
}

export async function createZone(organizationId: string, input: ZoneInput): Promise<Zone> {
  const response = await makeRequest({
    url: '/ops/zones',
    method: HttpMethods.POST,
    params: { organization_id: organizationId },
    data: input,
  }) as GenericResponse<Zone>;
  return response.result;
}

export async function updateZone(organizationId: string, zoneId: string, input: ZoneUpdateInput): Promise<Zone> {
  const response = await makeRequest({
    url: `/ops/zones/${zoneId}`,
    method: HttpMethods.PATCH,
    params: { organization_id: organizationId },
    data: input,
  }) as GenericResponse<Zone>;
  return response.result;
}

export async function archiveZone(organizationId: string, zoneId: string): Promise<void> {
  await makeRequest({
    url: `/ops/zones/${zoneId}`,
    method: HttpMethods.DELETE,
    params: { organization_id: organizationId },
  });
}

export async function getZoneCollectionPoints(
  organizationId: string,
  zoneId: string,
): Promise<ZoneCollectionPointsResponse> {
  const response = await makeRequest({
    url: `/ops/zones/${zoneId}/collection-points`,
    method: HttpMethods.GET,
    params: { organization_id: organizationId },
  }) as GenericResponse<ZoneCollectionPointsResponse>;
  return response.result;
}
